const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      style={{
        flexShrink: 0,
        minWidth: "12px",
        minHeight: "13px",
        maxWidth: "12px",
        maxHeight: "13px",
      }}>
      {/* Circle background */}
      <circle cx="6" cy="6.5" r="6" fill="#EF4444" />

      {/* Exclamation mark dot */}
      <rect x="5.4" y="8.3" width="1.2" height="1.2" fill="white" rx="0.6" />

      {/* Exclamation mark line */}
      <rect x="5.4" y="3.5" width="1.2" height="3.6" fill="white" rx="0.6" />
    </svg>
  );
};

export default ErrorIcon;
